// extracted by mini-css-extract-plugin
module.exports = {"Block3":"src-components-Main-Infos-Block3-Block3--1QtjD"};